import React, { useRef } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Tooltip,
  Menu,
  MenuItem,
  Button,
} from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";
import OptionsMenu, { OptionsMenuRef } from "./OptionsMenu";
import AdminHeaderOptions from "./AdminHeaderOptions";
import { logoStyle, logoStyleGDU2 } from "../styles/loginStyles";

export const transitionDuration = "0.8s";

interface UserHeaderProps {
  toggleColorMode: () => void;
  fullName: string;
  login: string;
  userType: number; // Tipo do usuário (1 = normal, 99 = admin)
}

const UserHeader: React.FC<UserHeaderProps> = ({
  toggleColorMode,
  fullName,
  login,
  userType,
}) => {
  const theme = useTheme();
  const optionsMenuRef = useRef<OptionsMenuRef>(null);

  const [adminMenuAnchorEl, setAdminMenuAnchorEl] = React.useState<null | HTMLElement>(null);

  const backgroundColor =
    theme.palette.mode === "dark" ? "#292929" : theme.palette.primary.main;

  const handleLogoutClick = () => {
    if (optionsMenuRef.current) {
      optionsMenuRef.current.openLogoutModal();
    }
  };

  const handleAdminMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAdminMenuAnchorEl(event.currentTarget);
  };

  const handleAdminMenuClose = () => {
    setAdminMenuAnchorEl(null);
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor,
          transition: `background-color ${transitionDuration} ease-in-out`,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            position: "relative",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", minWidth: 200 }}>
            <img
              src="/logo2.png"
              alt="Logo"
              style={{ width: "40px", height: "40px", marginRight: "10px" }}
            />
            <Typography
              variant="body1"
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {`${login} - ${fullName}`}
            </Typography>
          </Box>

          <Box
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
          <img src="/gdu2.0b.png" alt="Logo" style={logoStyleGDU2} />
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", minWidth: 100 }}>
            {userType === 99 && (
              <AdminHeaderOptions
                adminMenuAnchorEl={adminMenuAnchorEl}
                handleAdminMenuClick={handleAdminMenuClick}
                handleAdminMenuClose={handleAdminMenuClose}
              />
            )}
            <Tooltip title="Alterar Tema">
              <IconButton onClick={toggleColorMode} color="inherit">
                {theme.palette.mode === "dark" ? (
                  <Brightness7Icon />
                ) : (
                  <Brightness4Icon />
                )}
              </IconButton>
            </Tooltip>

            <Tooltip title="Sair (Logout)">
              <IconButton onClick={handleLogoutClick} color="inherit">
                <LogoutIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>

      {/* OptionsMenu conectado com toggleColorMode */}
      <OptionsMenu ref={optionsMenuRef} toggleColorMode={toggleColorMode} />
    </>
  );
};

export default UserHeader;
